import { Modal, Form, Button, Col, Row } from 'react-bootstrap';
import { Button as MyButton } from "./Button"
import { showAbandonedVehicleStatus } from "../api/EnumUtils";
import { abandonedVehicleStatuses } from "./AbandonedVehicleStatusArray";
import React from "react";
import { getStatusIcon } from "./AbandonedVehicleStatusIconNew";
import { showPercent } from "../common/Percent";

export interface DetectFilter {
    widthThr: number;
    heightThr: number;
    minConfThr: number;
    maxConfThr: number;
}

interface DetectFilterModalProps {
    show: boolean;
    onHide: () => void;
    filter: DetectFilter;
    setFilters: ( filters: DetectFilter ) => void;
}

export function DetectFilterModal( { show, onHide, filter, setFilters }: DetectFilterModalProps ) {
    const handleClose = () => {
        onHide();
    };

    const handleSliderChange = ( field: keyof DetectFilter, value: number ) => {
        performance.mark( "confThr Set" );
        setFilters( { ...filter, [field]: value } );
    };

    return <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
            <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="mb-4">
                <div className="mb-2">
                    <Form.Label>Minimum Confidence: {showPercent( filter.minConfThr )}</Form.Label>
                    <Form.Range
                        min={0}
                        max={1.0}
                        step={0.01}
                        value={filter.minConfThr}
                        onChange={( e ) => handleSliderChange( 'minConfThr', parseFloat( e.target.value ) )}
                    />
                </div>
                <div className="mb-2">
                    <Form.Label>Maximum Confidence: {showPercent( filter.maxConfThr )}</Form.Label>
                    <Form.Range
                        min={0}
                        max={1.0}
                        step={0.01}
                        value={filter.maxConfThr}
                        onChange={( e ) => handleSliderChange( 'maxConfThr', parseFloat( e.target.value ) )}
                    />
                </div>
                <div className="mb-2">
                    <Form.Label>Minimum Width: {filter.widthThr}</Form.Label>
                    <Form.Range
                        min={0}
                        max={100}
                        step={1}
                        value={filter.widthThr}
                        onChange={( e ) => handleSliderChange( 'widthThr', parseInt( e.target.value ) )}
                    />
                </div>
                <div className="mb-2">
                    <Form.Label>Minimum Height: {filter.heightThr}</Form.Label>
                    <Form.Range
                        min={0}
                        max={100}
                        step={1}
                        value={filter.heightThr}
                        onChange={( e ) => handleSliderChange( 'heightThr', parseInt( e.target.value ) )}
                    />
                </div>
            </div>
            <div className="d-flex gap-2">
                <MyButton className="w-100" onClick={onHide}>
                    Close
                </MyButton>
            </div>
        </Modal.Body>
    </Modal>;
}